import emailValidator from 'email-validator';
import glp from 'google-libphonenumber';
import _ from 'lodash';

//
// TODO use lodash everywhere.
//

export const validateRequired = (value, fieldName) => {
    let error = {};

    if (isEmptyString(value)) {
        error[fieldName] = 'Required field.';
    }

    return error;
};

export const validateEmail = (email, fieldName) => {
    let error = {};

    if (isEmptyString(email)) {
        return error;
    }

    if (!emailValidator.validate(email)) {
        error[fieldName] = 'Invalid email.';

    } else if (email.length > 250) {
        error[fieldName] = 'Email is too long.';
    }

    return error;
};

export const validatePhone = (phone, fieldName) => {
    let error = {};
    if (isEmptyString(phone)) {
        return phone;
    }

    let isValid = false;
    try {
        let phoneUtil = glp.PhoneNumberUtil.getInstance();
        let phoneNumber = phoneUtil.parse(phone, 'US');
        isValid = phoneUtil.isValidNumber(phoneNumber);

    } catch (error) {}

    if (!isValid) {
        error[fieldName] = 'Invalid US number.';
    }

    return error;
};

export const validateText = (text, fieldName, maxLength = 100) => {
    let error = {};

    if (isEmptyString(text)) {
        return error;
    }

    if (text.length > maxLength) {
        error[fieldName] = `Text is too long (${maxLength} characters maximum).`;
    }

    return error;
};

export const validateInteger = (text, fieldName) => {
    let error = {};

    if (isEmptyString(text)) {
        return error;
    }

    if (text != parseInt(text, 10)) {
        error[fieldName] = `Invalid integral number.`;
    }

    return error;
};

export const validateFloat = (text, fieldName) => {
    let error = {};

    if (isEmptyString(text)) {
        return error;
    }

    if (isNaN(parseFloat(text))) {
        error[fieldName] = `Invalid floating point number.`;
    }

    return error;
};

export const validateExpiry = (expiry, fieldName) => {
    const reg = /^(?:0[1-9])|(?:1[0-2])\/[0-9]{2}$/;
    const match = expiry.match(reg);
    const error = {};
    if (!match) {
        error[fieldName] = 'Invalid expiry.';
    }

    return error;
};

export const isEmptyObject = (obj) => {
    if (typeof obj === 'undefined' || obj == null) {
        return true;
    }

    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            return false;
        }
    }

    return true;
};

export const isEmptyString = (value) => {
    let empty = false;

    if ((typeof value === 'undefined') || (value === '') || (value == null)) {
        empty = true;
    }

    return empty;
};

export const isIdKey = (value) => {
    return ((value === 'id') || (value.endsWith('_id')));
};

export const isString = (value) => {
    return ((typeof(value) === 'string') || (value instanceof String));
};

export const isSavingNeeded = (currentProps, nextProps, currentPropsSavingNeeded = false, nextPropsSavingNeeded = false) => {
    let savingNeeded = false;
    if ((!nextPropsSavingNeeded) &&
        (!currentPropsSavingNeeded) &&
        (!nextProps.pristine)) {

        let serverError = '';
        try {
            ({
                serverError: serverError = ''
            } = nextProps);
        } catch(error) {}
        if (serverError) {
            savingNeeded = true;

        } else {
            let ignoreId = (obj, value = undefined, key = undefined) => {
                _.forOwn(obj, (value, key) => {
                    if (_.isObject(value)) {
                        _.forOwn(value, (valueNested, keyNested) => {
                            ignoreId(value, valueNested, keyNested);
                        });

                    } else if (isIdKey(key) || isEmptyString(value)) {
                        delete obj[key];
                    }
                });
            };

            let currentValues = _.cloneDeep(currentProps.values);
            let nextValues = _.cloneDeep(nextProps.values);
            ignoreId(currentValues);
            ignoreId(nextValues);
            savingNeeded = !_.isEqual(currentValues, nextValues);
        }
    }

    return savingNeeded;
};